module.exports = __webpack_public_path__ + "img/vertical_6_2_6000.80b6bb11.png";